/**
 * unload.js [AA 1/24]
 * --------------------
 * Pairs with 'preload.js'
 * Inserts deferred scripts, videos, and iframes into the document after content has loaded
 * Use the data attribute [data-load-priority] to skip deferring
 * @example
 * <script src="example.js" data-load-priority></script>
 * */

;(function unloadJS() {
  let script_loaded = false

  if (void 0 === window.uLTS) {
    window.uLTS = new MutationObserver((e) => {})
    window.uLTS.observe(document.documentElement, { childList: !0, subtree: !0 })
  }

  function loadIFrame(e) {
    const hasPriority = e.hasAttribute('data-load-priority')
    if (hasPriority) return

    null != (datasrc = e.dataset.src) && (e.src = datasrc)
    e.classList.add('iframe-loaded')
  }

  function loadVideo(e) {
    const hasPriority = e.hasAttribute('data-load-priority')
    if (hasPriority) return

    null != (datasrc = e.dataset.src) && (e.src = datasrc)
    e.classList.add('video-loaded')
    if (e.dataset.html) e.innerHTML = e.dataset.html
  }

  function loadScript(e) {
    const hasPriority = e.hasAttribute('data-load-priority')
    if (hasPriority) return

    var t = document.createElement('script')

    for (a = 0; a < e.attributes.length; a++) {
      var r = e.attributes[a]
      t.setAttribute(r.name, r.value)
    }

    t.innerHTML = e.innerHTML

    if (e.dataset.src) {
      t.src = e.dataset.src
    }

    if (e.dataset.type) {
      t.type = e.dataset.type
    } else {
      t.type = 'text/javascript'
    }

    e.parentNode.insertBefore(t, e)
    e.parentNode.removeChild(e)
  }

  function loadJSscripts() {
    if (!script_loaded) {
      void 0 !== window.uLTS && window.uLTS.disconnect()
      script_loaded = true

      document.querySelectorAll("script[type='text/lazyload']").forEach(loadScript)

      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('asyncLazyLoad'))
        document.dispatchEvent(new CustomEvent('loadBarInjector'))
      }, 500)
    }
  }

  function observeVideo(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !entry.target.classList.contains('video-loaded')) {
        loadVideo(entry.target)
      }
    })
  }

  function observeIframe(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !entry.target.classList.contains('iframe-loaded')) {
        loadIFrame(entry.target)
      }
    })
  }

  function initObservers() {
    if (typeof IntersectionObserver === 'function') {
      const options = {
        root: null,
        rootMargin: '120px',
        threshold: [0.025, 0.1],
      }

      const observer = new IntersectionObserver(observeVideo, options)

      document.querySelectorAll('video').forEach((el) => {
        observer.observe(el)
      })

      const iframeObserver = new IntersectionObserver(observeIframe, options)

      document.querySelectorAll('iframe[data-src]').forEach((el) => {
        iframeObserver.observe(el)
      })
    } else {
      document.querySelectorAll('video').forEach(loadVideo)
      document.querySelectorAll('iframe[data-src]').forEach(loadIFrame)
    }
  }

  ;(function init() {
    loadJSscripts()
    initObservers()
  })()
})()
